module.exports = __webpack_public_path__ + "static/media/bath-thub.b95ec7ed.svg";